export class DataDefinitionFieldMetaData {
    // display properties
    fieldName: string;
    includeInName: boolean = false;
    searchField: boolean = false;
    displayLabel?: string;
    includeInListDisplay: boolean = true;
    listDisplayOrder?: number;
    listDisplayColumnWidth: number = 100;

    constructor(fieldName: string) {
        this.fieldName = fieldName;
    }
}
